import { CATEGORY_BY_ID } from '../categories';
import type { Registration } from '../registry';

const n = CATEGORY_BY_ID.servo.colour;

export const servoRegistration: Registration = {
  definitions: [
    {
      type: 'esp32_servo_attach',
      message0: 'servo attach on pin %1',
      args0: [{ type: 'field_number', name: 'PIN', value: 18, min: 0, max: 48, precision: 1 }],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Attach a hobby servo to a PWM-capable pin (uses the ESP32Servo library).',
    },
    {
      type: 'esp32_servo_write',
      message0: 'set servo pin %1 angle %2 (0-180)',
      args0: [
        { type: 'field_number', name: 'PIN', value: 18, min: 0, max: 48, precision: 1 },
        { type: 'input_value', name: 'ANGLE', check: 'Number' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Move the servo to an angle between 0 and 180 degrees.',
    },
    {
      type: 'esp32_servo_write_us',
      message0: 'set servo pin %1 pulse %2 microseconds (500-2500)',
      args0: [
        { type: 'field_number', name: 'PIN', value: 18, min: 0, max: 48, precision: 1 },
        { type: 'input_value', name: 'US', check: 'Number' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Drive the servo with a raw pulse width in microseconds (fine control).',
    },
    {
      type: 'esp32_servo_read',
      message0: 'servo pin %1 current angle',
      args0: [{ type: 'field_number', name: 'PIN', value: 18, min: 0, max: 48, precision: 1 }],
      output: 'Number',
      colour: n,
      tooltip: 'The last angle written to the servo (0-180).',
    },
    {
      type: 'esp32_servo_detach',
      message0: 'servo pin %1 detach',
      args0: [{ type: 'field_number', name: 'PIN', value: 18, min: 0, max: 48, precision: 1 }],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Release the servo so it stops drawing power and can be moved by hand.',
    },
  ],
  metas: [
    {
      type: 'esp32_servo_attach',
      category: 'servo',
      label: 'Servo attach',
      description: 'Attach a hobby servo on a pin (put it in "when board starts").',
      fields: { PIN: { kind: 'number' } },
    },
    {
      type: 'esp32_servo_write',
      category: 'servo',
      label: 'Servo set angle',
      description: 'Move the servo to an angle (0-180). The pin is attached automatically.',
      fields: { PIN: { kind: 'number' }, ANGLE: { kind: 'value', types: 'Number' } },
    },
    {
      type: 'esp32_servo_write_us',
      category: 'servo',
      label: 'Servo set pulse',
      description: 'Drive the servo with a raw pulse width in microseconds (500-2500).',
      fields: { PIN: { kind: 'number' }, US: { kind: 'value', types: 'Number' } },
    },
    {
      type: 'esp32_servo_read',
      category: 'servo',
      label: 'Servo angle',
      description: 'Value: the last angle written to that servo.',
      fields: { PIN: { kind: 'number' } },
    },
    {
      type: 'esp32_servo_detach',
      category: 'servo',
      label: 'Servo detach',
      description: 'Detach the servo (stops the PWM signal).',
      fields: { PIN: { kind: 'number' } },
    },
  ],
};
